import { Badge, Box, Dialog, DialogContent, Divider, Grid, IconButton, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { adminUrl } from '../../../constants';
import { IoCloseCircleOutline } from 'react-icons/io5';


const NewsLetter = () => {

    // NewsletterGetAll

    const dispatch = useDispatch();
    const sessionUserId = sessionStorage.getItem("userId");

    const { NewsletterGetAll } = useSelector(state => state?.NewsletterGetAll);

    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getAllNewsletters`,
            };
            await dispatch(actions.NEWSLETTERGETALL(data1));
        };
        fetchData();
    }, [dispatch, sessionUserId]);

    const [openModal, setOpenModal] = useState(false);
    const [selectedAttachments, setSelectedAttachments] = useState([]);


    const handleAttachmentClick = (attachments) => {
        setSelectedAttachments(attachments);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedAttachments([]);
    };




    const newsletterData = [
        {
            title: 'TechFest 2024',
            date: '05/04/2023 – 30/04/20',
            description: 'Join us for an unforgettable day of innovation, workshops, and competitions at the annual TechFest!',
            emoji: '🚀',
        },
        {
            title: 'Cultural Night Extravaganza',
            date: '24/05/2023 – 24/05/2023',
            description: 'Experience the vibrant performances and traditions of our diverse college community at Cultural Night 2024.',
            emoji: '🧑‍🎤🎶',
        },
        {
            title: 'Sports Week Highlights',
            date: '01/06/2023 – 01/06/2023',
            description: 'Celebrate the spirit of teamwork and excellence with thrilling matches and champion moments from Sports Week!',
            emoji: '🏐⚽',
        },
    ];


    return (
        <Box p={2}>
            <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black" }}>
                News Letter
            </Typography>
            <Divider sx={{ mt: 1 }} />

            {NewsletterGetAll?.data?.length > 0 ? (
                <>
                    {NewsletterGetAll?.data?.map((item, index) => (
                        <Paper key={item.newsletter_id} elevation={1} sx={{ mb: 2, p: 2 }}>
                            <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600 }}>
                                {item.title}
                            </Typography>

                            <Typography sx={{ fontSize: "14px", color: "gray", mb: 1 }}>
                                {item.campus_name}
                                {/* &nbsp;|&nbsp; {new Date(item.createdAt).toLocaleDateString()} */}
                            </Typography>


                            {item.attach_files?.length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography sx={{ fontWeight: 600, mb: 1, color: "black" }}>Attachments:</Typography>
                                    <Grid
                                        sx={{border:"1px solid lightgray" ,p:2}}
                                    // container spacing={2}
                                    >
                                    <Grid size={{ xs: 12 }} item onClick={() => handleAttachmentClick(item.attach_files)} sx={{ cursor: 'pointer' }}>
                                        <Badge badgeContent={item.attach_files.length} color="primary">
                                            {item.attach_files[0]?.fileType === 'image' && (
                                                <img
                                                    src={`${adminUrl}${item.attach_files[0].fileUrl}`}
                                                    alt={item.attach_files[0].fileName}
                                                    style={{ width: "100%", borderRadius: 8 }}
                                                />
                                            )}
                                            {item.attach_files[0]?.fileType === 'video' && (
                                                <video width="100%" style={{ borderRadius: 8 }} controls>
                                                    <source src={`${adminUrl}${item.attach_files[0].fileUrl}`} type="video/mp4" />
                                                </video>
                                            )}
                                            {item.attach_files[0]?.fileType === 'pdf' && (
                                                <>
                                                    <Box
                                                        sx={{
                                                            border: '1px solid #ccc',
                                                            borderRadius: 2,
                                                            width: "100%",
                                                            height: 80,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: '#f9f9f9',
                                                        }}
                                                    >
                                                        <Typography>📄 PDF</Typography>
                                                    </Box>
                                                    <a
                                                        href={`${adminUrl}${item.attach_files[0].fileUrl}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            display: 'block',
                                                            padding: 8,
                                                            backgroundColor: '#f1f1f1',
                                                            borderRadius: 8,
                                                            textAlign: 'center',
                                                            textDecoration: 'none',
                                                        }}
                                                    >
                                                        📄 {item.attach_files[0].fileName}
                                                    </a>
                                                </>
                                            )}
                                        </Badge>
                                    </Grid>
                                </Grid>
                                </Box>
                    )}
                </Paper>
                    ))}
        </>
    ) : (<Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '67vh', // or adjust as needed
            width: '100%',
        }}
    >
        <Typography variant='subtitle1'>
            No newsletter post yet!
        </Typography>
    </Box>
    )
}
<Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
        <Typography variant="h6">Attachments</Typography>
        <IconButton onClick={handleCloseModal}>
            <IoCloseCircleOutline />
        </IconButton>
    </Box>
    <DialogContent dividers>
        <Grid container spacing={2}>
            {selectedAttachments.map((file, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                    {file.fileType === 'image' && (
                        <img
                            src={`${adminUrl}${file.fileUrl}`}
                            alt={file.fileName}
                            style={{ width: '100%', borderRadius: 8 }}
                        />
                    )}
                    {file.fileType === 'video' && (
                        <video width="100%" controls style={{ borderRadius: 8 }}>
                            <source src={`${adminUrl}${file.fileUrl}`} type="video/mp4" />
                        </video>
                    )}
                    {file.fileType === 'pdf' && (
                        <a
                            href={`${adminUrl}${file.fileUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'block',
                                padding: 8,
                                backgroundColor: '#f1f1f1',
                                borderRadius: 8,
                                textAlign: 'center',
                                textDecoration: 'none',
                            }}
                        >
                            📄 {file.fileName}
                        </a>
                    )}
                </Grid>
            ))}
        </Grid>
    </DialogContent>
</Dialog>
        </Box >
    )
}

export default NewsLetter